module.exports = __webpack_public_path__ + "static/media/居民住宅一体化供暖3.6aa2b10f.jpg";